import React, { Component } from "react";
import { NavBar, Footer } from "../components/ReusableElements";
import { NavLink } from "react-router-dom";
import policeman from "../assets/moderate-image.png";

const Actions = (props) => {
  return (
    // to do map list of actions out per account type
    <NavLink to={"/submitlistings"}>
      <button className="dashboard-moderate-option" type="button">
        <img src={policeman} alt="" height="100%" width="100%" />
        <body className="image-caption">Moderate Listings</body>
      </button>
    </NavLink>
  );
};

export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="home">
        <NavBar
          isLoggedIn={this.props.isLoggedIn}
          logout={this.props.toggleIsLoggedIn}
        />
        <div className="dashboard-box">
          <h1 className="home-title">What would you like to do today?</h1>
        </div>

        <Actions accountType={this.props.user.account_type} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js